import AuthRepository from './AuthRepository'
import UserRepository from './UserRepository'
import PatientRepository from './PatientRepository'
import MonitorRepository from './MonitorRepository'
import CashDeskRepository from './CashDeskRepository'
import SamplingStationRepository from './SamplingStationRepository'
import UserLogRepository from './UserLogRepository'
import ErrorLogRepository from './ErrorLogRepository'
import CategoryRepository from './CategoryRepository'
import TestRepository from './TestRepository'
import IndicationRepository from './IndicationRepository'
import OrderRepository from './OrderRepository'
import BioanalystRepository from './BioanalystRepository'
import ContentRepository from './ContentRepository'
import PaymentMethodRepository from './PaymentMethodRepository'
import InternalConfigurationRepository from './InternalConfigurationRepository'
import SyncHistoryRepository from './SyncHistoryRepository'
import AppointmentRepository from './AppointmentRepository'
import AppointmentConfigRepository from './AppointmentConfigRepository'
import HomeAppointmentRepository from './HomeAppointmentRepository'
import MonitorConfigRepository from './MonitorConfigRepository'

const repositories = {
  auth: AuthRepository,
  users: UserRepository,
  patients: PatientRepository,
  monitors: MonitorRepository,
  cashDesks: CashDeskRepository,
  samplingStations: SamplingStationRepository,
  userLogs: UserLogRepository,
  errorLogs: ErrorLogRepository,
  categories: CategoryRepository,
  tests: TestRepository,
  indications: IndicationRepository,
  orders: OrderRepository,
  contents: ContentRepository,
  bioanalysts: BioanalystRepository,
  paymentMethods: PaymentMethodRepository,
  internalConfiguration: InternalConfigurationRepository,
  syncHistories: SyncHistoryRepository,
  appointments: AppointmentRepository,
  homeAppointments: HomeAppointmentRepository,
  appointmentConfig: AppointmentConfigRepository,
  monitorConfig: MonitorConfigRepository,
}
export default {
  get: (name) => repositories[name],
}
